import { render, staticRenderFns } from "./SchoolBaseCard.vue?vue&type=template&id=0a92adc8&scoped=true&"
import script from "./SchoolBaseCard.vue?vue&type=script&lang=js&"
export * from "./SchoolBaseCard.vue?vue&type=script&lang=js&"
import style0 from "./SchoolBaseCard.vue?vue&type=style&index=0&id=0a92adc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a92adc8",
  null
  
)

export default component.exports